<template>
	<v-row no-gutters align="stretch">
		<v-col cols="12" sm="6" class="pr-sm-2">
			<v-menu
				ref="menu"
				v-model="datePicker"
				:close-on-content-click="false"
				:return-value.sync="daily_report.report_date"
				transition="scale-transition"
				offset-y
				min-width="auto"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="daily_report.report_date"
						label="日付（必須）"
						class="mt-4"
						readonly
						outlined
						dense
						v-bind="attrs"
						v-on="on"
						:rules="[rules.required]"
					></v-text-field>
				</template>
				<v-date-picker v-model="daily_report.report_date" no-title scrollable locale="ja-JP">
					<v-spacer />
					<v-btn text color="primary" @click="datePicker = false"> キャンセル </v-btn>
					<v-btn text color="primary" @click="$refs.menu.save(daily_report.report_date)">
						決定
					</v-btn>
				</v-date-picker>
			</v-menu>
			<v-row class="pa-0 ma-0 mt-4" align-content="center">
				<v-text-field
					type="time"
					outlined
					dense
					v-model="daily_report.start_at"
					:rules="[rules.required]"
					label="開始時間（必須）"
				/>
				<span class="pa-2 text-body-1"> 〜 </span>
				<v-text-field
					type="time"
					outlined
					dense
					v-model="daily_report.end_at"
					:rules="[rules.required]"
					label="終了時間（必須）"
				/>
			</v-row>

			<v-text-field
				v-model="daily_report.title"
				label="件名（必須）"
				class="mt-4"
				type="text"
				dense
				:rules="[rules.required]"
				outlined
			/>

			<v-text-field
				v-model="daily_report.place"
				label="場所"
				type="text"
				class="mt-4"
				dense
				outlined
			/>

			<v-textarea
				v-model="daily_report.memo"
				label="報告内容（必須）"
				class="mt-4"
				outlined
				:rules="[rules.required]"
			/>
			<DailyReportFileForm
				v-if="daily_report.daily_report_meta_values_attributes.length >= 5"
				:dailyReportFiles.sync="daily_report.files"
				:existing_files="daily_report.existing_files"
				:report_id="daily_report.id"
			/>
		</v-col>
		<v-col cols="12" sm="6" class="pl-sm-2">
			<DailyReportMetaValueForm
				v-for="(metaValue, i) in daily_report.daily_report_meta_values_attributes"
				:metaKey="metaKey(metaValue)"
				:meta_value.sync="daily_report.daily_report_meta_values_attributes[i]"
				:key="i"
			/>
			<DailyReportFileForm
				v-if="daily_report.daily_report_meta_values_attributes.length < 5"
				:dailyReportFiles.sync="daily_report.files"
				:existing_files="daily_report.existing_files"
				:report_id="daily_report.id"
			/>
		</v-col>
	</v-row>
</template>

<script>
import moment from "moment/min/moment.min.js"
import axios from "axios"
import rules from "../../../helper/rules"
import errorHandling from "../../../helper/errorHandling"
import DailyReportMetaValueForm from "./DailyReportMetaValueForm.vue"
import DailyReportFileForm from "./DailyReportFileForm.vue"
import authenticate from "../../../helper/authenticate"

export default {
	components: {
		DailyReportMetaValueForm,
		DailyReportFileForm,
	},
	props: {
		dailyReport: {
			type: Object,
			required: true,
			default: () => ({
				id: { type: Number, required: false, default: null },
				title: { type: String, required: true, default: null },
				place: { type: String, required: false, default: null },
				memo: { type: String, required: true, default: null },
				report_date: { type: String, required: true, default: null },
				start_at: { type: String, required: true, default: null },
				end_at: { type: String, required: true, default: null },
				matter_id: { type: Number, required: false, default: null },
				files: { type: Array, required: true, default: () => [] },
				existing_files: { type: Array, required: false, default: () => [] },
				daily_report_meta_values_attributes: { type: Array, required: true, default: () => [] },
			}),
		},
		template: {
			type: Object,
			required: true,
			default: {
				id: {
					type: Number,
					required: true,
					default: null,
				},
				name: {
					type: String,
					required: true,
					default: null,
				},
				meta_keys: {
					type: Array,
					required: false,
					default: () => [],
				},
			},
		},
		meta_keys: {
			type: Array,
			required: false,
			default: () => [
				{
					id: {
						type: Number,
						required: true,
						default: null,
					},
					name: {
						type: String,
						required: true,
						default: null,
					},
					required_flag: {
						type: Boolean,
						required: true,
						default: false,
					},
					meta_type: {
						type: String,
						required: true,
						default: null,
					},
				},
			],
		},
	},
	filters: {
		dateFormatter(date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
		timeFormatter(time) {
			if (!time) return ""
			return moment(time).format("HH:mm")
		},
	},
	data() {
		return {
			rules: rules,
			datePicker: false,
			existingFiles: [],
		}
	},

	computed: {
		metaKey() {
			return (metaValue) => {
				return this.template.meta_keys.find((m) => m.id == metaValue.daily_report_meta_key_id)
			}
		},
		hours() {
			const hours = [...Array(24)].map((_, i) => i)
			return hours
		},
		minutes() {
			const minutes = [...Array(60)].map((_, i) => i)
			return minutes
		},
		allFiles() {
			return this.daily_report.files?.length + this.existingFiles.length
		},
		daily_report: {
			get() {
				return this.dailyReport
			},
			set() {
				return this.$emit("update:dailyReport", newValue)
			},
		},
	},
}
</script>


<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";

.result-area {
	position: relative;
	.result-list {
		background-color: white;
		position: absolute;
		width: 100%;
		height: 300px;
		overflow: scroll;
		z-index: 1;
		box-shadow: 2px 2px 5px gray;
		.result-unit {
			padding: 4px;
			cursor: pointer;
			&:hover {
				background-color: whitesmoke;
			}
		}
	}
	.no-result {
		padding: 4px;
	}
}
</style>